import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Import de l'extension

import translationFR from "./locales/fr.json";
import translationEN from "./locales/en.json";

const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
};

i18n
  .use(LanguageDetector) // Utilise le détecteur automatique
  .use(initReactI18next)
  .init({
    resources,
    // On retire "lng: savedLanguage", car le détecteur s'en occupe tout seul !
    fallbackLng: "fr",
    detection: {
      // Ordre de priorité : localStorage d'abord, sinon langue du navigateur
      order: ['localStorage', 'navigator'],
      // Nom de la clé dans le localStorage (i18next utilise 'i18nextLng' par défaut)
      lookupLocalStorage: 'language', 
      caches: ['localStorage'], // Sauvegarde auto après chaque changement
    },
    interpolation: { escapeValue: false },
  });

export default i18n;